import { jsx } from "react/jsx-runtime";
import VALoanCalculator from "../VALoanCalculator/VALoanCalculator.esm.js";
const FHACalculatorBlock = {
  Component: () => {
    return /* @__PURE__ */ jsx(VALoanCalculator, { isFHAEnabled: true });
  },
  metadata: {
    version: "1.0",
    name: "constellation/fha-calculator",
    title: "FHA Calculator",
    description: "Estimate your monthly payment, taxes and down payment needed to qualify for an FHA mortgage loan.",
    icon: "chart-line",
    category: "Calculators",
    keywords: ["mortgages", "calculators", "fha", "first", "time", "homebuyers"],
    supports: {
      customClassName: false,
      html: false
    }
  }
};
export {
  FHACalculatorBlock as default
};
